import { Image } from 'expo-image';
import { useRouter } from 'expo-router';
import { View } from 'react-native';
import { UnistylesRuntime, useStyles } from 'react-native-unistyles';

import { Button, Text } from '@/ui';

const darkImgSrc = require('../../../public/images/partners/eon-one/eonone-logo-dark.png');
const lightImgSrc = require('../../../public/images/partners/eon-one/eonone-logo-light.png');

export default function EonOneMobile() {
  const { theme } = useStyles();
  const router = useRouter();

  return (
    <View
      style={{
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        gap: 16,
        backgroundColor: theme.colors.background_1,
      }}
    >
      <View style={{ width: '100%' }}>
        <Image
          style={{
            width: '100%',
            height: 100,
          }}
          source={
            UnistylesRuntime.themeName === 'dark' ? darkImgSrc : lightImgSrc
          }
          contentFit="contain"
        />
      </View>

      <View style={{ gap: 8 }}>
        <Text type="title2" style={{ textAlign: 'center' }}>
          Best Viewed On Desktop
        </Text>

        <Text
          type="bodyRegular"
          style={{ color: theme.colors.text.secondary, textAlign: 'center' }}
        >
          Setting up your branding, domain, and fleet needs more room than a
          phone. Open EonOne on a computer to pick up where you left off.
        </Text>
      </View>

      <View>
        <Button
          text="Go Back"
          type="secondarySmall"
          onPress={() => {
            if (router.canGoBack()) {
              router.back();
            } else {
              router.replace('/partner/dashboard');
            }
          }}
        />
      </View>
    </View>
  );
}
